<template>
  <div>
    <router-view>

    </router-view>

    <van-tabbar v-model="active">
      <van-tabbar-item v-for="pathName in menuList" :icon="getIconName(pathName)" :to="pathName" :key="pathName">
        {{ getTitle(pathName)}}
      </van-tabbar-item>
    </van-tabbar>

  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import { Icon, NavBar, Tabbar, TabbarItem } from 'vant'
import store from '@/store'

const OrderPathName = 'orders'
const CustomersPathName = 'customers'
const PersonPathName = 'person'
const OrderIconName = 'orders-o'
const CustomersIconName = 'friends-o'
const PersonIconName = 'setting-o'

export default {
  name: 'layout',
  components: {
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem
  },
  data() {
    return {
      active: 0,
      menuList: [],
      orderMenu: ['Unpaid', 'PartUnpaid', 'Paid', 'Picking', 'Shipped', 'RequestRefund', 'Completed', 'RefundFinished', 'Closed']
    }
  },
  computed: {
    pathActive: function() {
      return this.menuList.indexOf(this.$route.path.substring(1))
    }
  },
  watch: {
    pathActive: function(newValue) {
      this.active = newValue
    }
  },
  mounted: function() {
    if (this.$route.path === '/') {
      this.$router.replace('/' + this.menuList[0])
    }
  },

  methods: {
    generateCustomizeString,
    initMenu() {
      var res = []
      for (var i = 0; i < this.orderMenu.length; i++) {
        if (store.getters.menu.includes('Order') || store.getters.menu.includes(this.orderMenu[i])) {
          res.push(OrderPathName)
        }
      }
      for (var j = 0, len = res.length; j < len; j++) {
        var current = res[j]
        if (this.menuList.indexOf(current) === -1) {
          this.menuList.push(current)
        }
      }

      if (store.getters.menu.includes('MemberManager')) {
        this.menuList.push(CustomersPathName)
      }

      // 至少 push 一个个人中心进去
      this.menuList.push(PersonPathName)
    },
    getIconName(menuName) {
      var iconName = ''
      switch (menuName) {
        case OrderPathName :
          iconName = OrderIconName
          break
        case CustomersPathName :
          iconName = CustomersIconName
          break
        case PersonPathName :
          iconName = PersonIconName
          break
      }
      return iconName
    },
    getTitle(menuName) {
      var title = ''
      switch (menuName) {
        case OrderPathName :
          title = this.generateCustomizeString('orders')
          break
        case CustomersPathName :
          title = this.generateCustomizeString('customers')
          break
        case PersonPathName :
          title = this.generateCustomizeString('setting')
          break
      }
      return title
    }
  },
  created: function() {
    this.initMenu()
  },
  destroyed: function() {

  }
}
</script>

<style scoped>
</style>
